import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { fetchTradeInDeviceBrands, setTradeInDeviceBrand } from 'store/widgets/TradeInNewCalculator/brand/actions';
import { tradeInValidate } from 'store/widgets/TradeInNewCalculator/common/actions';
import { setTradeInDeviceType } from 'store/widgets/TradeInNewCalculator/deviceType/actions';

export interface BrandState {
  isError: boolean;
  isFetching: boolean;
  data: string[];
  title: string;
  slug: string;
  selectedValue: string;
  isValid: boolean;
}

const initialState: BrandState = {
  isError: false,
  isFetching: false,
  data: [],
  slug: '',
  title: '',
  selectedValue: '',
  isValid: true,
};

const resetState = (state: BrandState) => {
  state.isError = false;
  state.isFetching = false;
  state.data = [];
  state.selectedValue = '';
  state.isValid = true;
};

const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<BrandState>) => {
    builder
      .addCase(tradeInValidate, (state) => {
        state.isValid = state.selectedValue !== '';
      })
      .addCase(setTradeInDeviceBrand, (state, action) => {
        state.selectedValue = action.payload;
        state.isValid = true;
      })
      .addCase(fetchTradeInDeviceBrands.pending, state => {
        state.isError = false;
        state.isFetching = true;
      })
      .addCase(fetchTradeInDeviceBrands.fulfilled, (state, { payload }) => {
        state.isError = false;
        state.isFetching = false;
        state.data = payload || [];
      })
      .addCase(fetchTradeInDeviceBrands.rejected, state => {
        state.isError = true;
        state.isFetching = false;
      })
      .addCase(setTradeInDeviceType, resetState);
  },
});

export default brandSlice.reducer;
